import styles from 'molecules/TextCard/headingtextcard.module.scss';

import type { HeadingCardProps } from 'molecules/TextCard/headingtextcard.config';
import type { FC } from 'react';

const HeadingCard: FC<HeadingCardProps & { className?: string }> = ({ heading, subheading, className }) => (
  <article className={`${styles.wrapper} ${className || ''}`}>
    {heading && <h3 className={styles.title}>{heading}</h3>}
    {subheading && <h3 className={styles.title}>{subheading}</h3>}
  </article>
);

export default HeadingCard;
